import { Treatment } from "../models/treatment";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export function createTreatment(treatment: Treatment): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/submit`,
    method: "POST",
    body: treatment,
  };
}

export interface GetTreatmentDetailParams {
  registrationId?: string;
  treatmentId?: string;
  medicalRecord?: number;
}

export function getTreatment(params: GetTreatmentDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/detail`,
    method: "GET",
    params,
  };
}

export interface GetTreatmentListParams {
  current: number;
  medicalRecord?: number;
  size?: number;
  param?: string;
  patientId?: string;
  treatmentDepartmentId?: string;
  treatmentDoctorId?: string;
  treatmentTimeHead?: string;
  treatmentTimeTail?: string;
}

export function getTreatmentList(params: GetTreatmentListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/page`,
    method: "GET",
    params,
  };
}

export interface CopyTreatmentParams {
  registrationId?: string;
  srcTreatmentId: string;
  copyRecipe: boolean;
  copyWithAmount?: boolean;
}

export function copyTreatment(params: CopyTreatmentParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/copy`,
    method: "POST",
    body: params,
  };
}

export function getTreatmentNotice(patientId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/notice`,
    method: "GET",
    params: {
      patientId,
    },
  };
}
export function getTab(registrationId?: any): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/selectmenu`,
    method: "GET",
    params: {
      registrationId,
    },
  };
}

export interface urlLinkParams {
  fileName?: any;
  bucketName?: any;
}
export function getUrlLink(params: urlLinkParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/oss/endpoint/file-link`,
    method: "GET",
    params,
  };
}

export interface tabStateParams {
  medicalRecord?: number;
  registrationId?: string;
}

export function getCutTab(body: tabStateParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/checkrepetition`,
    method: "POST",
    body,
  };
}
